import Color from '../Color.mjs'
import superMeta from '../_COMMON/metaCommonNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    name: '超链接',
    type: 'URL',
}
